import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
// Custom components
import React, { useEffect, useState } from 'react';
import { IoSearchOutline } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { userExcelReports, userReports } from '../../../redux/actions/Report.action';
import userPhoto from '../../../assets/img/user.png'
import AppoinmentView from 'views/admin/addAppointment/AppoinmentView';
import { appointementGetById } from '../../../redux/actions/Files.action';
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import { BsDownload } from 'react-icons/bs';
import { Button } from 'react-bootstrap';
import * as XLSX from 'xlsx';

export default function UserReport() {

    const dispatch = useDispatch();
    const reportData = useSelector((state) => state.report)
    console.log('reportData',reportData);

    const [formData, setFormData] = useState({
        createdAt: '',
        startDate: '',
        endDate: '',
        search: ''
    })
    const [viewModal, setViewModal] = useState(false);
    const viewToggle = () => { setViewModal(!viewModal); };
    const [currentDate, setCurrentDate] = useState('');
    const [feedbackId, setFeedbackId] = useState()
    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isExporting, setIsExporting] = useState(false);

    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    };

    const data = {
        date: currentDate
    }

    useEffect(() => {
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];

        setCurrentDate(formattedDate);
    }, []);

    const handleFormData = (e) => {
        const { name, value } = e.target;
        setFormData((prev => ({
            ...prev,
            [name]: value,
            ...(name === 'startDate' || name === 'endDate' ? { createdAt: '' } : {}),
            ...(name === 'createdAt' ? { startDate: '', endDate: '' } : {})
        })))
    }

    const ChangeMainPage = ({ selected }) => {
        setMainPage(selected + 1);
    };
    const totalRecords = reportData?.userReport?.data?.totalPatients || 0;
    const PageCount = Math.ceil(totalRecords / rowsPerPage);

    useEffect(() => {

        let payload = {}
        if (formData.createdAt) {
            payload.createdAt = formData.createdAt
        }
        if (formData.startDate || formData.endDate) {
            payload.startDate = formData.startDate;
            payload.endDate = formData.endDate;
        }
        if (formData) {
            dispatch(userReports(formData.search, limits, payload))
        }
    }, [formData,mainPage, rowsPerPage])

    const handleAppointment = (id) => {
        dispatch(appointementGetById(id))
    }

    const formatTime = (dateString) => {
        const date = new Date(dateString);

        let hours = date.getUTCHours();
        const minutes = date.getUTCMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';

        hours = hours % 12;
        hours = hours || 12;

        const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;

        return `${hours}:${minutesFormatted} ${ampm}`;
    };

    const handleExport = () => {
        const data = {
          createdAt: formData.createdAt,          
          startDate: formData.startDate,
          endDate: formData.endDate,
        };
        dispatch(userExcelReports(formData.search,data));
        setIsExporting(true);
      };
    
      useEffect(() => {
        if (
          isExporting &&
          reportData?.getUserExcelData?.data?.patients?.length
        ) {
          const exportData = reportData?.getUserExcelData?.data?.patients.map((res) => ({
            Date: res.createdAt ? moment(res.createdAt).format('DD/MM/YYYY') : '',
            Branch: res.branch,
            'First Name': res.firstName,
            'Middle Name': res.middleName,
            'Last Name': res.lastName,
            'Phone No.': res.phoneNumber,
            Gender: res.gender,
            'Date Of Birth': res.dateOfBirth ? moment(res.dateOfBirth).format('DD/MM/YYYY') : '',
            Country: res.country,
            State: res.state,
            City: res.city,
            Area: res.area,
            'Lead Received On': res.leadReceived,
            Problem: res.problem,
            'Lead Status': res.leadStatus,
            'Lead From': res.leadFrom,
            Campaign: res.campaign[0]?.cname || '',
            'Campaign Detail': res.campaign[0]?.description || '',
            Reference: res?.reference[0]?.doctorDetail || res?.reference[0]?.personDetail || '',
            Remark: res.remark,
            'Next Followup Date': res.nextFollowUpDate ? moment(res.nextFollowUpDate).format('DD/MM/YYYY') : '',
            From: res.from ? formatTime(res.from) : '',
            To: res.to ? formatTime(res.to) : '',
            Nationality: res.nationality,
            'Doctor Name': res.doctorName,
            'Counsellor Assign': res.counselorAssign,
            Occupation: res.occupation,
            Email: res.email,
            Address: res.address,
            'Blood Group': res.bloodGroup,
            Pincode: res.pincode,
            'Lead FollowUp Remark': res.leadFollowUpRemark,
            User: res.leadGeneratedByName,
          }));
      
          const ws = XLSX.utils.json_to_sheet(exportData);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "User Reports");
      
          XLSX.writeFile(wb, "User_Report.xlsx");
          setIsExporting(false);
        }
      }, [reportData?.getUserExcelData?.data?.patients]);

    return (
        <>
            <div className="mt-[100px]">
                <div className="d-flex items-center gap-3">
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">Date</label>
                        <input
                            type="date"
                            name="createdAt"
                            value={formData.createdAt}
                            onChange={handleFormData}
                            className="w-75 outline-none !border-b"
                        />
                    </div>
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">Start Date</label>
                        <input
                            type="date"
                            name="startDate"
                            value={formData.startDate}
                            onChange={handleFormData}
                            className="w-75 outline-none !border-b"
                        />
                    </div>
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">End Date</label>
                        <input
                            type="date"
                            name="endDate"
                            value={formData.endDate}
                            onChange={handleFormData}
                            className="w-75 outline-none !border-b"
                        />
                    </div>
                    <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2 ms-auto">
                        <IoSearchOutline />
                        <input
                            type="text"
                            name="search"
                            value={formData.search}
                            onChange={handleFormData}
                            className="w-full outline-none"
                            placeholder="Search..."
                        />
                    </div>
                    <div className="me-2">
                        <Button
                            className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                            onClick={handleExport}  
                        >
                            <BsDownload className="mt-1 me-2" />
                            Download
                        </Button>
                    </div>
                </div>
                <div className='border-r text-end mt-4 pe-3 me-3'>Total Records: <span className='text-success border-b border-success'>{reportData?.userReport?.data?.totalPatients || 0}</span></div>
            </div>
            <div className="mt-[50px] mb-4">
                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Date</Th>
                                <Th>Branch</Th>
                                <Th>First Name</Th>
                                <Th>Middle Name</Th>
                                <Th>Last Name</Th>
                                <Th>Phone No.</Th>
                                <Th>Gender</Th>
                                <Th>Date Of Birth</Th>
                                <Th>Country</Th>
                                <Th>State</Th>
                                <Th>City</Th>
                                <Th>Area</Th>
                                <Th>Lead Received On</Th>
                                <Th>Problem</Th>
                                <Th>Lead Status</Th>
                                <Th>Lead From</Th>
                                <Th>Campaign</Th>
                                <Th>Campaign Detail</Th>
                                <Th>Referance</Th>
                                <Th>Remark</Th>
                                <Th>Next Followup Date</Th>
                                <Th>From</Th>
                                <Th>To</Th>
                                <Th>Nationality</Th>
                                <Th>Dctor Name</Th>
                                <Th>Counsellor assign</Th>
                                <Th>Occupation</Th>
                                <Th>Email</Th>
                                <Th>Address</Th>
                                <Th>Blood Group</Th>
                                <Th>Pincode</Th>
                                <Th>Photo</Th>
                                <Th>Lead FollowUp Remark</Th>
                                <Th>User</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                reportData?.userReport?.data?.patients?.length > 0 ? (
                                    reportData?.userReport?.data?.patients?.map((res) => {
                                        return (
                                            <Tr key={res._id} onClick={() => { viewToggle(); handleAppointment(res.appointmentId); setFeedbackId(res.patientId) }}>
                                                {/* <Tr key={res._id}> */}
                                                <Td>{res.createdAt ? moment(res.createdAt).format('DD/MM/YYYY') : ''}</Td>
                                                <Td>{res.branch}</Td>
                                                <Td className='capitalize'>{res.firstName}</Td>
                                                <Td className='capitalize'>{res.middleName}</Td>
                                                <Td className='capitalize'>{res.lastName}</Td>
                                                <Td>{res.phoneNumber}</Td>
                                                <Td>{res.gender}</Td>
                                                <Td>{res.dateOfBirth ? moment(res.dateOfBirth).format('DD/MM/YYYY') : ''}</Td>
                                                <Td>{res.country}</Td>
                                                <Td>{res.state}</Td>
                                                <Td>{res.city}</Td>
                                                <Td>{res.area}</Td>
                                                <Td>{res.leadReceived}</Td>
                                                <Td>{res.problem}</Td>
                                                <Td className="capitalize">
                                                    <span className={`cursor-pointer ${res.leadStatus === "new" || res.leadStatus === "New"
                                                        ? "bg-[#198754] text-white px-3 py-1 rounded inline-block text-sm"
                                                        : res.leadStatus === "close"
                                                            ? "bg-[#0d6efd] text-white px-3 py-1 rounded inline-block text-sm"
                                                            : res.leadStatus === "exit"
                                                                ? "bg-[#dc3545] text-white px-3 py-1 rounded inline-block text-sm"
                                                                : res.leadStatus === "pending"
                                                                    ? "bg-[#ffc107] text-black px-3 py-1 rounded inline-block text-sm"
                                                                    : res.leadStatus === "pipeline"
                                                                        ? "bg-[#0dcaf0] text-white px-3 py-1 rounded inline-block text-sm"
                                                                        : res.leadStatus === "inProcess"
                                                                            ? "bg-[#fd7e14] text-white px-3 py-1 rounded inline-block text-sm"
                                                                            : res.leadStatus === "counsultation done"
                                                                                ? "bg-[#6c757d] text-white px-3 py-1 rounded inline-block text-sm"
                                                                                : "bg-transparent text-black"}`}>{res.leadStatus}</span>
                                                </Td>
                                                <Td>{res.leadFrom}</Td>
                                                <Td>{res.campaign[0]?.cname}</Td>
                                                <Td>{res.campaign[0]?.description}</Td>
                                                <Td>{res?.reference[0]?.doctorDetail ? `${res?.reference[0]?.doctorDetail}` : res?.reference[0]?.personDetail}</Td>
                                                <Td>{res.remark}</Td>
                                                <Td>{res.nextFollowUpDate ? moment(res.nextFollowUpDate).format('DD/MM/YYYY') : ''}</Td>
                                                <Td>{res.from ? formatTime(res.from) : ''}</Td>
                                                <Td>{res.to ? formatTime(res.to) : ''}</Td>
                                                <Td>{res.nationality}</Td>
                                                <Td>{res.doctorName}</Td>
                                                <Td>{res.counselorAssign}</Td>
                                                <Td>{res.occupation}</Td>
                                                <Td>{res.email}</Td>
                                                <Td>{res.address}</Td>
                                                <Td>{res.bloodGroup}</Td>
                                                <Td>{res.pincode}</Td>
                                                <Td><img src={res.photo || userPhoto} alt='user photo' width='50px' /></Td>
                                                <Td>{res.leadFollowUpRemark}</Td>
                                                <Td>{res.leadGeneratedByName}</Td>
                                            </Tr>
                                        )
                                    })
                                ) : (
                                    <Tr>
                                        <Td colSpan={32} textAlign={'center'}>No any report</Td>
                                    </Tr>
                                )
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>
            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={ChangeMainPage}
                pageRangeDisplayed={5}
                pageCount={PageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                className="pagination"
            />

            <AppoinmentView viewModal={viewModal} setViewModal={setViewModal} viewToggle={viewToggle} currentDate={currentDate} data={data} limits={limits} feedbackId={feedbackId} />
        </>
    );
}
